import styled from "styled-components";
import media from 'styled-media-query';

export const Container = styled.div`
  position: relative;
  margin-top: 30px;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;

  .row {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 25px;
    margin-bottom: 2rem;
  }
  
  .grid-item {
    width: 100%;
    min-height: 340px;
  }
  
  /* Estilo para o placeholder vazio */
  .empty-placeholder {
    display: none; /* Ocultar os placeholders */
  }
  
  .no-results {
    grid-column: 1 / -1;
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: #6b7280;
  }
  
  /* Responsividade para diferentes tamanhos de tela */
  @media (min-width: 768px) {
    .row {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (min-width: 992px) {
    .row {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  @media (min-width: 1200px) {
    .row {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  @media (min-width: 1400px) {
    .row {
      grid-template-columns: repeat(4, 1fr);
    }
  }
  
  /* Estilo para o botão "Mostrar mais" */
  .text-center {
    margin-top: 2rem;
    margin-bottom: 1rem;
    text-align: center;
    
    button {
      min-width: 180px;
      padding: 0.7rem 1.5rem;
      border-radius: 8px;
      background: linear-gradient(90deg, #3454D1, #0891b2);
      border: none;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      font-size: 1rem;
      font-weight: 600;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
        background: linear-gradient(90deg, #294bc7, #077991);
      }
    }
  }
`;
